// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"SectionToolbar_toolbar__mpB1F","action":"SectionToolbar_action__mEHCo","delete":"SectionToolbar_delete__mly4y"};